/****************************************************
 * Module Name:  departmentgroup.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class DepartmentGroupProxy {
  static GetAllDepartmentGroup = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/departmentgroup",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllDepartmentGroupDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/departmentgroup/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDepartmentGroupDetail = (id, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/departmentgroup/${id}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDepartmentGroup = (departmentgroupId, callback) => {
    let params = {
      id: departmentgroupId,
    };

    restAPICall(
      Constants.MANAGER_URL + `/departmentgroup`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckDepartmentGroupAvailable = (departmentgroup, callback) => {
    let params = {
      departmentgroup: departmentgroup,
    };

    restAPICall(
      Constants.MANAGER_URL + "/departmentgroup/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddDepartmentGroup = (departmentgroup, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/departmentgroup",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(departmentgroup),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateDepartmentGroup = (departmentgroup, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/departmentgroup",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(departmentgroup),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
